import React from 'react';

const STATES = {
  live: { dot: 'bg-green-500', text: 'text-green-400', label: 'LIVE NOW', pulse: true },
  idle: { dot: 'bg-amber-400', text: 'text-amber-300/90', label: 'IDLE' },
  offline: { dot: 'bg-white/25', text: 'text-white/35', label: 'OFFLINE' },
};

export default function RigStatusBadge({ status }) {
  const s = STATES[status];
  if (!s) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[9px] font-bold tracking-widest ${s.text}`}>
      <span className={`relative inline-flex w-1.5 h-1.5 rounded-full ${s.dot}${s.pulse ? ' animate-pulse' : ''}`} />
      {s.label}
    </span>
  );
}